export const styles = ({ palette }) => ({
  paperWidthMd: {
    width: '40%',
    overflow: 'visible',
  },
  paperWidthSm: {
    overflow: 'visible',
    padding: '10px 20px 10px 20px',
  },
  panel: {
    padding: '10px 20px 10px 20px',
    background: palette.white,
  },
  inputFields: {
    fontSize: '16px',
    paddingBottom: 2,
    textAlign: 'left',
  },
  inputFieldsBold: {
    fontSize: '16px',
    fontWeight: 800,
    paddingBottom: 2,
    textAlign: 'left',
  },
  labelBold: {
    fontWeight: 500,
    fontSize: '15px',
    marginLeft: 0,
  },
  container: {
    marginBottom: 2,
    marginLeft: 24,
    paddingRight: 24,
    background: palette.white,
    overflow: 'auto',
  },
  formGroup: {
    alignItems: 'start',
    marginTop: 20,
    marginBottom: 20,
  },
  formControlLabel: {
    marginRight: 0,
    marginLeft: 0,
    flexDirection: 'row-reverse',
    '&.bottomSpace': {
      marginBottom: 20,
    },
  },
  txList: {
    minWidth: 470,
    flex: 1,
    '&.right': {
      paddingLeft: 2,
      borderLeft: 'solid',
      borderLeftWidth: '1px',
      borderLeftColor: palette.blue1,
    },
  },
  buttonHolder: {
    textAlign: 'right',
    marginTop: 5,
    marginBottom: 5,
    marginRight: 5,
    background: palette.white,
    display: 'flex',
  },
  buttonHolderWithTotal: {
    textAlign: 'right',
    marginRight: 5,
    background: palette.white,
    display: 'flex',
    minHeight: 42,
    height: '100%',
    marginTop: 10,
    marginBottom: 10,
  },
  markAllLabel: {
    paddingLeft: 30,
    paddingTop: 12,
  },
  separator: {
    paddingTop: 10,
  },
  divider: {
    height: 2,
    backgroundColor: palette.koalaGrey,
  },
  divFormControlLabel: {
    marginLeft: 10,
  },
  divFlex: {
    display: 'flex',
  },
  divFlexFull: {
    flex: 1,
  },
  divPaddingLeft20: {
    paddingLeft: 20,
  },
  paperReconcileWorkspace: {
    flex: 1,
    textAlign: 'left',
    display: 'flex',
  },
});


